export default "__VITE_ASSET__Dq3ocKLS__"